import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const DownloadDownwardArrowIcon: FC<SVGComponentProps> = ({
  width = 13,
  height = 14
}) => {
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 13H0.5M10.5 6.33333L6.5 10.3333M6.5 10.3333L2.5 6.33333M6.5 10.3333V1"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { DownloadDownwardArrowIcon };
